import {formatoFechaExportacion} from "../../Utilidades/formatoFechaExportacion";

export const adaptador_conductores_exportacion = (conductores) => {


    let arr = []
    for (let i = 0; i < conductores.length; i++) {
        let condu = conductores[i]
        let obj = {
            fecha: formatoFechaExportacion(condu.fecha),
            nombres: condu.nombres,
            apellidos: condu.apellidos,
            cc: condu.cc,
            estado: condu.estado

        }
        arr.push(obj)
    }

    return arr

}